import { BlurEvent, DropdownSelectionEvent, LookupModelSelectionEvent, TableRow, Textbox, TableContentsChangedEvent, TableAction, LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutMiscInvoiceTaxTable } from "./autogen/AutogenLayoutMiscInvoiceTaxTable";
import { Currency, CurrencySettings, ModelRow } from "@mcleod/core";

export class MiscInvoiceTaxTable extends AutogenLayoutMiscInvoiceTaxTable {
    currencyCode: string; // Used for multicurrency currency code when new taxes are added.
    billDate: Date; // Used for multicurrency exchange rate when new taxes are added.
    private recalculatingTaxes: boolean = false;

    textboxExciseTaxIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection() === true) {
            const textbox = event.target as Textbox;
            const tableRow = TableRow.getContainingTableRow(textbox);
            const modelRow: ModelRow = tableRow?.data as ModelRow;
            modelRow?.set("descr", event.selection.getString("descr", ""));
            tableRow?.displayComponentValues();
        }
    }

    textboxStateIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.country_id = "in CAN,CAD"; // show only Canadian provinces
    }

    textboxTaxMethodAfterDropdownSelection(event: DropdownSelectionEvent) {
        const textbox = event.target as Textbox;
        const tableRow = TableRow.getContainingTableRow(textbox);
        const modelRow: ModelRow = tableRow.data as ModelRow;
        if (modelRow) {
            this.recalculateAmount(tableRow,modelRow);
        }
    }

    textboxUnitsOnBlur(event: BlurEvent) {
        this.textboxOnBlur(event);
    }

    textboxRateOnBlur(event: BlurEvent) {
        this.textboxOnBlur(event);
    }

    textboxOnBlur(event: BlurEvent) {
        if (event.changedWhileFocused) {
            const textbox = event.target as Textbox;
            const tableRow = TableRow.getContainingTableRow(textbox);
            const modelRow: ModelRow = tableRow.data as ModelRow;
            if (modelRow) {
                this.recalculateAmount(tableRow, modelRow);
            }
        }
    }

    private recalculateAmount(tableRow: TableRow, modelRow: ModelRow) {
        if (this.recalculatingTaxes) {
            return;
        }

        this.recalculatingTaxes = true;
        try {
            const units = modelRow.getNumber("units", 0);
            const rate = modelRow.getNumber("rate", 0);
            if (units != null && rate != null) {
                let amount = 0;
                const method = modelRow.getString("method", "");
                if ("P" === method) { // Percentage
                    amount = Number.parseFloat(((units * rate) / 100).toFixed(2));
                } else { // Flat
                    amount = Number.parseFloat((units * rate).toFixed(2));
                }

                const currencyCode = this.currencyCode || CurrencySettings.getTransactionalCurrency();
                const conversionDate = this.billDate || new Date();
                const amountCurrency = new Currency({ amount, currency_code: currencyCode, conversion_date: conversionDate });
                modelRow.updateCurrency("amount", amountCurrency);

                // Trigger parent's tax total calculation
                this.tableExciseTaxes.fireContentsChangedListener(new TableContentsChangedEvent(this.tableExciseTaxes, TableAction.UPDATE));
            }
        } finally {
            tableRow?.displayComponentValues();
            this.recalculatingTaxes = false;
        }
    }

    updateMulticurrencyAmounts() {
        this.tableExciseTaxes.rows.forEach((tableRow) => {
            const modelRow: ModelRow = tableRow.data;
            if (modelRow && !modelRow.isNull("amount")) {
                const amount = modelRow.getCurrency("amount", new Currency(0));
                amount.setCurrencyCode(this.currencyCode || CurrencySettings.getTransactionalCurrency());
                amount.setConversionDate(this.billDate || new Date());
                modelRow.updateCurrency("amount", amount);
            }
        });
    }
}
